import Vue from "vue";
import Router from "vue-router";
import App from "@/App.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Protected from "./views/Protected.vue";
import Avatar from "./views/Avatar.vue";
import Concert from "./views/Concert.vue";
import Discovery from "./views/Discovery.vue";
import SFDW from "./views/SFDW.vue";
import System from "./views/System.vue";
import i18n from "./i18n";
import Yoyolumi from "./views/Yoyolumi.vue";
import Lume from "./views/Lume.vue";
import { ACTIVE_LOCALE, ENGLISH_ONLY } from "./utils/locale-routing";
Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: `/${ENGLISH_ONLY ? ACTIVE_LOCALE : i18n.locale}`
    },
    {
      path: "/:lang/astrounaut",
      beforeEnter() {
        location.href =
          "http://yingyingchen.com/project_Internastronaut/Internastronaut.html";
      }
    },
    {
      path: "/:lang",
      component: App,
      children: [
        {
          path: "/",
          name: "home",
          components: { default: Home, header: MainNavbar, footer: MainFooter },
          props: {
            header: {
              type: "white",
              colorOnScroll: 400,
              initalTextColor: "black",
              shouldShowName: false,
              logo_type: "default"
            },
            footer: { backgroundColor: "white", shouldShowWorkSection: false }
          },
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "about",
          name: "about",
          components: {
            default: About,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "white",
              colorOnScroll: 400,
              initalTextColor: "black",
              shouldShowName: false,
              logo_type: "default"
            },
            footer: { backgroundColor: "white", shouldShowWorkSection: false }
          },
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "protected",
          name: "protected",
          components: { default: Protected, header: MainNavbar },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            preivousRouter: String
          },
          meta: {
            requiresAuth: false
          }
        },
        {
          path: "concert",
          name: "concert",
          components: {
            default: Concert,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "avatar",
          name: "avatar",
          components: {
            default: Avatar,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "discovery",
          name: "discovery",
          components: {
            default: Discovery,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "sfdw",
          name: "sfdw",
          components: { default: SFDW, header: MainNavbar, footer: MainFooter },
          props: {
            header: {
              type: "white",
              colorOnScroll: 400,
              initalTextColor: "black",
              shouldShowName: true,
              logo_type: "black"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "system",
          name: "system",
          components: {
            default: System,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "lume",
          name: "lume",
          components: {
            default: Lume,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#FFFFFF", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "yoyolumi",
          name: "yoyolumi",
          components: {
            default: Yoyolumi,
            header: MainNavbar,
            footer: MainFooter
          },
          props: {
            header: {
              type: "black",
              colorOnScroll: 400,
              initalTextColor: "white",
              shouldShowName: true,
              logo_type: "white"
            },
            footer: { backgroundColor: "#F7F7F7", shouldShowWorkSection: true }
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
